import { Injectable } from '@angular/core';
import { RestClientService } from 'src/app/core/services/rest/rest-client.service';
import { ConditionRetail } from '../model/condition-retail';

@Injectable({
    providedIn: 'root'
  })
  export class ConditionRetailService{
  
    
    constructor(private _restClientService : RestClientService) 
    {}

    getConditionRetailsByRetailItemId(retailItemId) {
      return this._restClientService.load<ConditionRetail[]>('condition-retail/conditions-retail-by-retailitemid/'+retailItemId);
    }
    
    getConditionRetailById(conditionId) {
      return this._restClientService.load<ConditionRetail>('condition-retail/conditions-retail-by-id/'+conditionId);
    }
          
    putConditionRetail(condition: ConditionRetail) {
      return this._restClientService.put<void>('condition-retail/update-condition-retail', condition);
    }
  
    postConditionRetail(condition: ConditionRetail) {
      return this._restClientService.save<void>('condition-retail/add-condition-retail', condition);
    }

    deleteConditionRetail(conditionId){
      return  this._restClientService.delete<void>('condition-retail/delete-condition-retail/'+conditionId);
    }


  
        

  



}      

    